<template>
	<div class="sl-editor" :id="attributeName + '__area'">
		<div class="col-sm-5">
			<AttributeLabel
				:attributeName="attributeName"
				:localizedTitle="localizedTitle"
				:is-primary="isPrimary"
				:is-multiple="isMultiple"
				:max-count="maxCount"
				:sl-attribute="true"
				:enable-copy-attribute-name="enableCopyAttributeName"
				:lang="language"
				:index="index"
				:rich-text="hasFormatRichText"
				:locked-edit="lockedEdit"
				@rich-text-handler="richTextHandler"
			/>
		</div>
		<template v-if="hasFormatRichText">
			<div class="col-sm-7">
				<div class="rich-text-view">
					<div class="rich-text-editor-default" v-html="attributeValue"/>
					<input type="hidden" :id="attributeName + '__' + language" :value="attributeValue">
				</div>
				<button v-if="!lockedEdit" class="rich-text-editor-reset fa fa-times" @click="resetRichTextEditor"/>
			</div>
		</template>
		<template v-else>
			<div class="col-sm-7">
				<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
					<div :class="SINGLE_ATTRIBUTE" v-if="maxLength > 200">
					<textarea :class="'textarea-split attribute-editor sl-hotkey ' + getDefaultValueWithLockClasses()"
							  :id="attributeName + '__' + language"
							  :maxlength="maxLength"
							  :value="attributeValue"
							  :disabled="lockedEdit"/>
						<button v-if="!lockedEdit" class="button_reset multiple-area-reset fa fa-times"/>
					</div>
					<div :class="SINGLE_ATTRIBUTE" v-else>
						<input type="text" :id="attributeName + '__' + language"
							   :class="'textInput-split attribute-editor sl-hotkey ' + getDefaultValueWithLockClasses()"
							   :maxlength="maxLength"
							   :value="attributeValue"
							   :disabled="lockedEdit">
						<button v-if="!lockedEdit" :class="'button_reset fa fa-times ' + getDefaultValueWithLockClasses()"/>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import { Fragment } from 'vue-fragment'
import defaultClassManager from '../../mixins/defaultClassManager'
import { richTextEditor } from 'utils/rich-text-editor'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'

export default {
	components: {
		AttributeLabel,
		Fragment
	},
	mixins: [defaultClassManager],
	name: 'SLAttributeEditorComponent',
	props: [
		'attributeName',
		'isPrimary',
		'language',
		'index',
		'itemConfig',
		'itemData',
		'enableCopyAttributeName',
		'lockedEdit'
	],
	data () {
		return {
			SINGLE_ATTRIBUTE: 'single-attribute'
		}
	},
	computed: {
		attributeValue: function () {
			if (this.itemData) {
				return this.itemData[this.attributeName] ? this.itemData[this.attributeName][this.language] : ''
			} else {
				return ''
			}
		},
		localizedTitle () {
			return String(this.itemConfig.title)
		},
		isMultiple () {
			return this.itemConfig.multiple
		},
		maxLength () {
			return this.itemConfig.maxLength
		},
		maxCount () {
			return this.itemConfig.maxCount
		},
		defaultValue () {
			return this.itemConfig.defaultValue
		},
		defaultLock () {
			return this.itemConfig.defaultLock
		},
		colspan () {
			return this.itemConfig.colspan
		},
		expression () {
			return this.itemConfig.expression
		},
		sequence () {
			return this.itemConfig.sequence
		},
		hasFormatRichText () {
			return this.itemConfig.format === 'RICH_TEXT'
		},
		type () {
			return this.itemConfig.type
		}
	},
	directives: {
		bindShowLangsList: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'showLangsList(\'' + binding.value + '\', null);')
			}
		},
		bindCopyComponentSL: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'copyComponentSL(\'' + binding.value + '\');')
			}
		},
		bindHideLangsList: {
			inserted: function (el, binding) {
				el.setAttribute('onblur', 'hideLangsList(\'' + binding.value + '\');')
			}
		},
		bindCopyToClipboard: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'CopyToClipboard(\'' + binding.value + '\', this)')
			}
		}
	},
	methods: {
		richTextHandler () {
			richTextEditor(this)
		},
		resetRichTextEditor () {
			if (this.itemData && this.itemData[this.attributeName]) {
				this.$delete(this.itemData[this.attributeName], this.language)
				this.$nextTick(() => {
					attributeChangesRegister(this.attributeName)
				})
			} else {
				this.$el.getElementsByClassName('rich-text-editor-default')[0].innerText = ""
				this.$el.getElementsByTagName('input')[0].value = ""
			}
		},
	}
}
</script>

<style scoped>
</style>
